import { render } from "./pegawai-riwayat.vue?vue&type=template&id=2772ac18"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__